import {
  AlphanumericRegex,
  CreateDynamicSchema,
  FieldConfig,
  NotAllowPipeRegex,
  RequiredField,
} from "./formik";

// Configuration array defining validation rules
const config: FieldConfig[] = [
  RequiredField("type", "Exception type is required"),
  RequiredField("reporting", "Reporting terminal is required"),
  {
    name: "proNumber",
    type: "number",
    nullable: true,
    when: {
      key: "type",
      value: "AS",
      required: true,
      message: "Pro number is required",
      max: 11,
      maxMessage: "Pro number must be less than or equal to 11 digits",
    },
  },
  RequiredField("origin", "", false),
  RequiredField("destination", "", false),
  RequiredField("shipperAccount", "", false),
  RequiredField("shipper", "", false),
  RequiredField("shipperAddress", "", false),
  RequiredField("shipperCity", "", false),
  RequiredField("shipperState", "", false),
  RequiredField("shipperZip", "", false),
  RequiredField("consigneeAccount", "", false),
  RequiredField("consignee", "", false),
  RequiredField("consigneeCity", "", false),
  RequiredField("consigneeState", "", false),
  RequiredField("consigneeZip", "", false),
  RequiredField("consigneeAddress", "", false),
  {
    name: "lastManifest",
    type: "number",
    required: true,
    message: "Last manifest number# is required",
    positive: true,
    max: 9,
    maxMessage: "Last manifest number# must be less than or equal to 9 digits",
  },
  RequiredField("trailerOrBay", "Please select trailer or bay/dock"),

  {
    name: "trailer",
    type: "string",
    when: {
      key: "trailerOrBay",
      value: "T",
      required: true,
      message: "Trailer number# is required",
    },
    matches: AlphanumericRegex,
    matchesMessage:
      "Invalid trailer number, only alphanumerical characters allowed",
  },

  {
    name: "manifest",
    type: "number",
    when: {
      key: "trailerOrBay",
      value: "T",
      required: true,
      message: "Manifest number# is required",
    },
    positive: true,
    max: 9,
    maxMessage: "Manifest number# must be less than or equal to 9 digits",
  },

  {
    name: "bay",
    type: "string",
    when: {
      key: "trailerOrBay",
      value: "B",
      required: true,
      message: "Bay/Dock number is required",
    },
    matches: AlphanumericRegex,
    matchesMessage:
      "Invalid bay number, only alphanumerical characters allowed",
  },
  RequiredField("commodity", "Commodity is required"),
  RequiredField("package", "Package is required"),
  RequiredField("pieces", "Total pieces are required", true, "number"),
  RequiredField("weight", "Weight is required", true, "number"),
  RequiredField("itemCartonModelSerialNumber",  "Does the shipment have (Item#, Carton#, Model#, Serial#) is required"),
  RequiredField("valueRange", "Value range is required"),
  {
    name: "value1k",
    type: "number",
    nullable: true,
    when: {
      key: "valueRange",
      value: "3",
      required: true,
      message: "Amount is required",
      moreThan: 1000,
      moreThanMessage: "Amount must be greater than 1000",
      lessThan: 9999999999,
      lessThanMessage: "Amount must be greater than 1000",
    },
  },
  {
    name: "dimension",
    type: "string",
    required: true,
    message: "Dimension is required",
    matches: NotAllowPipeRegex,
    matchesMessage: "Special character | is not allowed",
  },
  {
    name: "packagingDescription",
    type: "string",
    required: true,
    message: "Packaging description is required",
    matches: NotAllowPipeRegex,
    matchesMessage: "Special character | is not allowed",
  },
  {
    name: "productDescription",
    type: "string",
    required: true,
    message: "Product description is required",
    matches: NotAllowPipeRegex,
    matchesMessage: "Special character | is not allowed",
  },

  {
    name: "agentInterline",
    type: "string",
    matches: NotAllowPipeRegex,
    matchesMessage: "Special character | is not allowed",
  },
  {
    name: "additionalDescription",
    type: "string",
    required: true,
    message: "Description is required",
    matches: NotAllowPipeRegex,
    matchesMessage: "Special character | is not allowed",
    max: 450,
    maxMessage:
      "Additional description must be less than or equal to 450 characters",
  },
];
// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const ShortageEntryNBSchema = CreateDynamicSchema(config);

export const InitAllShortageFormValue = {
  type: "AS",
  reporting: "",
  proNumber: "",
  origin: "",
  destination: "",
  shipperAccount: "",
  consigneeAccount: "",
  shipper: "",
  shipperAddress: "",
  shipperCity: "",
  shipperState: "",
  shipperZip: "",
  consigneeCity: "",
  consigneeState: "",
  consigneeZip: "",
  consignee: "",
  consigneeAddress: "",
  itemCartonModelSerialNumber: "",
  weight: "",
  lastManifest: "",
  manifest: "",
  trailer: "",
  bay: "",
  commodity: "",
  package: "",
  pieces: "",
  valueRange: "",
  dimension: "",
  packagingDescription: "",
  additionalDescription: "",
  productDescription: "",
  agentInterline: "",
  trailerOrBay: "",
  value1k: null,
};
